import { BsBackspace } from 'react-icons/bs';
import { Button } from 'react-bootstrap';
import { generalBlue } from 'src/app-config';
import { useEffect, useState } from 'react';
import { useGetIsMobile } from 'src/custom-hooks';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

export const ReturnBtn = () => {
    const [show, setShow] = useState(false);
    const isMobile = useGetIsMobile();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (['/', '/acceso', '/nuevo-usuario', '/selector'].includes(location.pathname)) {
            return setShow(false);
        }
        if (['edificio'].includes(location.pathname.split('/')[1])) {
            return setShow(false);
        }
        setShow(true);
    }, [location.pathname]);

    if (!show) {
        return <></>;
    }

    return (
        <div
            style={{
                left: '0',
                marginLeft: '10px',
                marginTop: isMobile ? '15px' : '10px',
                position: 'fixed',
                top: isMobile ? 0 : undefined,
                zIndex: isMobile ? 9999 : 3
            }}
        >
            <Button size={isMobile ? 'sm' : undefined}
                className={isMobile ? 'border' : ''}
                style={{
                    backgroundColor: generalBlue,
                    border: '1px solid ' + generalBlue,
                    borderRadius:' 5px'
                }}
                onClick={() => navigate(-1)}
            >
                <BsBackspace style={{ paddingBottom: '3px' }} /> VOLVER &nbsp;
            </Button>
        </div>
    );
}
